import React from 'react';

import Logo from '../assets/logo.svg'

const Header = () => {
  return(
    <header className='py-8'>
     <div className='container mx-auto'>
      <div className='flex justify-between items-center'>

        <a href='#'>
        <button class="btn bg-gradient-to-r from-pink-600 to-blue-800 text-white text-lg border-2 border-pink-600 rounded-md px-6 py-3 transform hover:scale-105 transition duration-300">Vishesh Tiwari</button>








        </a>
        <a href='mailto:tvishesh593@gmail.com'>
        <button className='btn btn-sm'>Work with Me</button>
        </a>
        

      </div>
      
      
      </div>;
  </header>
  )
  

};

export default Header;
